import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CardTagLine from './CardTagLine';
import Avatar from './Avatar';

export default class DiscussionRow extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    shortTimeAgo: PropTypes.string.isRequired,
    shortTimeAgoTitle: PropTypes.string.isRequired,
    tags: PropTypes.array,
    maxTags: PropTypes.number,
    participants: PropTypes.array.isRequired,
    viewsCount: PropTypes.number.isRequired,
    commentsCount: PropTypes.number.isRequired,
  };

  static defaultProps = {
    tags: [],
    maxTags: 2,
  };

  renderTags() {
    return (
      <CardTagLine
        className="u-mt-2 md:u-mt-5"
        seeMoreURL={this.props.url}
        tags={this.props.tags}
        maxTags={this.props.maxTags}
        keyIdentifier={this.props.title}
      />
    );
  }

  render() {
    const renderedAvatars = this.props.participants
      .slice(0, this.props.participants.length > 5 ? 4 : 5)
      .map((participant) => (
        <Avatar
          src={participant.avatar}
          href={participant.url}
          name={participant.name}
          headline={participant.headline}
          hover
          className="Avatar--medium u-align-middle u-mr-1 u-ml-1 md:u-mr-px md:u-ml-px first:u-ml-0 last:u-mr-0  u-w-7 u-h-7 md:u-w-5 md:u-h-5"
          key={participant.url}
        />
      ));
    const remainingAvatars = this.props.participants.length - (this.props.participants.length > 5 ? 4 : 5);

    return (
      <tr className="u-bg-white u-border-b u-border-grey-lighter">
        <td className="u-px-0 u-py-4 u-align-top u-bg-white u-truncate u-max-w-px u-text-old-primary-color-blue">
          <a className="u-font-semibold u-text-lg md:u-text-base" href={this.props.url}>
            {this.props.title}
          </a>
          <div className="md:u-hidden">
            <div className="u-text-old-primary-color u-text-base u-mt-1">
              <i className="Icon-views u-mr-1 u-align-bottom" />
              {this.props.viewsCount}
              <i className="Icon-comment u-mr-1 u-ml-2 u-align-bottom" />
              {this.props.commentsCount}
              <i className="Icon-activity u-mr-1 u-ml-2 u-align-bottom" />
              <span title={this.props.shortTimeAgoTitle}>{this.props.shortTimeAgo}</span>
            </div>
            <div className="u-mt-2">
              {renderedAvatars}
              {remainingAvatars > 0 && (
                <div className="u-inline-block u-h-7 u-w-7 u-bg-grey-darker u-text-xs u-rounded-full u-text-white u-text-center u-align-middle">
                  {`+${remainingAvatars}`}
                </div>
              )}
            </div>
          </div>
          {this.renderTags()}
        </td>
        <td className="u-text-base u-py-4 u-align-top u-bg-white u-text-old-primary-color u-whitespace-no-wrap u-hidden md:u-table-cell">
          {this.props.viewsCount}
        </td>
        <td className="u-text-base u-py-4 u-align-top u-bg-white u-text-old-primary-color u-whitespace-no-wrap u-hidden md:u-table-cell">
          {this.props.commentsCount}
        </td>
        <td className="u-text-base u-py-4 u-align-top u-bg-white u-text-old-primary-color u-whitespace-no-wrap u-hidden md:u-table-cell">
          <span title={this.props.shortTimeAgoTitle}>{this.props.shortTimeAgo}</span>
        </td>
        <td className="u-bg-white u-py-4 u-align-top u-px-0 u-whitespace-no-wrap u-hidden md:u-flex">
          {renderedAvatars}
          {remainingAvatars > 0 && (
            <div className="u-inline-block u-h-5 u-w-5 u-bg-grey-darker u-text-xxxs u-rounded-full u-text-white u-text-center u-align-middle">
              {`+${remainingAvatars}`}
            </div>
          )}
        </td>
      </tr>
    );
  }
}
